// extracted by mini-css-extract-plugin
export default {"colorsDebugger":"ColorsDebugger_colorsDebugger__p1WzS","select":"ColorsDebugger_select__+H79L","colorExample":"ColorsDebugger_colorExample__Ohk1N"};